import axios from "./axios"

/**
 * Get car evaluation from Wayke
 * @param string reg - Car registration number
 * @param integer mileage - Car mileage
 * @return object 
 */
async function getCarEvaluationData(reg, mileage) {
    const km = parseInt(mileage) * 10;
    const query = `tradein?regNo=${reg}&km=${km}`;
    const response = await axios.get(query);

    // testdata:
    // const response = {data:{"requestId":"d5b633e9-4914-4890-b49e-e93c7baaaff7","registrationNumber":"AAA750","price":{"prediction":155700,"projectedPrediction":null,"min":67000,"max":119900,"avg":94500,"wayke":null,"marketValueIndex":1.647619},"dataUsed":{"manufacturer":"Volkswagen","km":50000,"modelName":"2.0 TDI BlueMotion 4Motion","modelSeries":"Passat","county":null,"hasTowbar":false,"fuelType":"Diesel","gearboxType":"Automat","chassis":"Kombi","equipmentLevel":"Premium, Sport","color":"Svart","modelYear":2013,"seatCount":5,"vinNumber":"WVWZZZ3CZDE013339","salesName":"Passat Variant","drivingWheel":"Fyrhjulsdrift","segment":"Stor Familjebil","enginePower":170}}};

    return response.status === 200 
        ? response.data
        : false
}

export default getCarEvaluationData